import apiEndPoints from '../utils/ctxUtil';
import { adalApiFetch } from '../adalConfig';

export function batchProcessListHasErrored(bool) {
  return {
    type: 'BATCH_PROCESS_LIST_HAS_ERRORED',
    hasErrored: bool,
  };
}
export function batchProcessListIsRunning(bool) {
  return {
    type: 'BATCH_PROCESS_LIST_IS_LOADING',
    isLoading: bool,
  };
}
export function batchProcessListSuccess(items) {
  return {
    type: 'BATCH_PROCESS_LIST_SUCCESS',
    items,
  };
}

export function runBatchProcessHasErrored(bool, message) {
  return {
    type: 'RUN_BATCH_PROCESS_HAS_ERRORED',
    hasErrored: bool,
    message: message,
  };
}
export function runBatchProcessIsRunning(bool) {
  return {
    type: 'RUN_BATCH_PROCESS_IS_LOADING',
    isLoading: bool,
  };
}
export function runBatchProcessSuccess(items) {
  return {
    type: 'RUN_BATCH_PROCESS_SUCCESS',
    items,
  };
}

export function rollbackBatchProcessHasErrored(bool, message) {
  return {
    type: 'ROLLBACK_BATCH_PROCESS_HAS_ERRORED',
    hasErrored: bool,
    message: message,
  };
}
export function rollbackBatchProcessIsRunning(bool) {
  return {
    type: 'ROLLBACK_BATCH_PROCESS_IS_LOADING',
    isLoading: bool,
  };
}
export function rollbackBatchProcessSuccess(items) {
  return {
    type: 'ROLLBACK_BATCH_PROCESS_SUCCESS',
    items,
  };
}

export function batchProcessListFetchData() {
  const url = apiEndPoints.BATCH_PROCESS;
  return (dispatch) => {
    dispatch(batchProcessListIsRunning(true));

    adalApiFetch(fetch, url, {})
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }

        return response.json();
      })
      .then((items) => {
        dispatch(batchProcessListSuccess(items));
        dispatch(batchProcessListIsRunning(false));
      })
      .catch(() => {
        dispatch(batchProcessListHasErrored(true));
        dispatch(batchProcessListIsRunning(false));
      });
  };
}

export function runBatchProcessData(batchProcess) {
  const url = apiEndPoints.BATCH_PROCESS_RUN;
  return async (dispatch) => {
    dispatch(runBatchProcessHasErrored(false, ''));
    dispatch(runBatchProcessIsRunning(true));
    try {
      const response = await adalApiFetch(fetch, url, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        body: JSON.stringify(batchProcess),
        headers: { 'Content-Type': 'application/json' },
      });
      dispatch(runBatchProcessIsRunning(false));
      const data = await response.json();
      if (!response.ok) {
        dispatch(runBatchProcessHasErrored(true, data.message));
        throw new Error(response.status);
      }
      dispatch(batchProcessListFetchData(true));
      dispatch(runBatchProcessSuccess(data));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error running batch process:', error);
      dispatch(runBatchProcessHasErrored(true));
    }
  };
}

export function rollbackBatchProcessData(id) {
  const url = apiEndPoints.BATCH_PROCESS_ROLLBACK.replace('id', id);

  return async (dispatch) => {
    dispatch(rollbackBatchProcessHasErrored(false, ''));
    dispatch(rollbackBatchProcessIsRunning(true));
    try {
      const response = await adalApiFetch(fetch, url, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: { 'Content-Type': 'application/json' },
      });
      dispatch(rollbackBatchProcessIsRunning(false));
      const data = await response.json();
      if (!response.ok) {
        dispatch(rollbackBatchProcessHasErrored(true, data.message));
        throw new Error(response.status);
      }
      dispatch(batchProcessListFetchData(true));
      dispatch(rollbackBatchProcessSuccess(true, data));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('Error rolling back batch process:', error);
      dispatch(rollbackBatchProcessHasErrored(true, error.message));
    }
  };
}
